import AuthenticationContext from "@/contexts/AuthenticationContext";
import { useGlobalLoader } from "@/hooks/useGlobalLoader";
import { useAuthentication } from "@thrivecoin/authentication-v2";
import { useEffect } from "react";

export function AuthenticationProvider({ children }: { children: React.ReactNode }) {
  const {
    user,
    loading,
    loginModal,
    logout: _logout,
    isAuthenticating,
    refreshUser,
    isWaitingWalletChangeWebhook,
  } = useAuthentication();
  const { show, hide } = useGlobalLoader();

  useEffect(() => {
    if (isWaitingWalletChangeWebhook) {
      show({
        timeoutOptions: {
          time: 10,
          message: "Wallet link failed!",
        },
      });
    } else {
      hide();
    }
  }, [isWaitingWalletChangeWebhook]);

  const logout = () => {
    _logout();
  };

  const value = {
    user,
    loading,
    logout,
    loginModal,
    isAuthenticating,
    refreshUser,
    isWaitingWalletChangeWebhook,
  };

  return <AuthenticationContext.Provider value={value}>{children}</AuthenticationContext.Provider>;
}
